"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var hasProp = function hasProp(props, any) {
    if (Array.isArray(any)) {
        return any.reduce(function (acc, prop) {
            return acc || hasProp(props, prop);
        }, false);
    }
    return props && any && any in props;
};

exports.default = hasProp;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-a11y/lib/util/has-prop.js
// module id = 1621
// module chunks = 101 102